import { createAction } from 'redux-actions';

export const createSuccessAction = type =>
  createAction(type, (items, ids, count, itemToEditId) => ({
    items,
    ids,
    count,
    itemToEditId,
  }));
